import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

export default function MembershipUSPs({ className, children, ...restProps }) {
  return (
    <ul
      className={mergeClasses('m-0 list-none space-y-1 p-0', className)}
      {...restProps}
    >
      {children}
    </ul>
  );
}

MembershipUSPs.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

MembershipUSPs.defaultProps = {
  className: ''
};
